import { jsx, jsxs, Fragment } from "react/jsx-runtime";
import { ConversationHistoryDrawer } from "../ConversationHistoryDrawer/index.js";
import { useState } from "react";
import { PanelLeft, ShoppingBag, SquarePen } from "lucide-react";
import { HeaderWidget } from "@brandclub/bc-widgets";
const getFontWeight = (weight) => {
  const weights = { normal: 400, medium: 500, semibold: 600, bold: 700 };
  return weights[weight] || 600;
};
const ConciergeHeader = ({
  onMenuToggle,
  onComposeClick,
  onConversationSelect,
  showComposeIcon = true,
  cartCount = 0,
  onBagClick
}) => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const handleMenuToggle = () => {
    setIsDrawerOpen(!isDrawerOpen);
    onMenuToggle == null ? void 0 : onMenuToggle();
  };
  const handleDrawerClose = () => {
    setIsDrawerOpen(false);
  };
  const handleConversationSelect = (conversationId) => {
    onConversationSelect == null ? void 0 : onConversationSelect(conversationId);
  };
  const handleBagClick = () => {
    onBagClick == null ? void 0 : onBagClick();
  };
  return /* @__PURE__ */ jsx(HeaderWidget, { widgetId: "concierge-header", displayName: "Concierge Header", children: (state, resolveColor) => /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsxs(
      "header",
      {
        style: {
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          paddingTop: state.paddingY,
          paddingBottom: state.paddingY,
          paddingLeft: state.paddingX,
          paddingRight: state.paddingX,
          marginLeft: "auto",
          marginRight: "auto",
          width: "100%",
          maxWidth: state.maxWidth,
          height: state.height,
          backgroundColor: resolveColor(state.backgroundColor)
        },
        children: [
          /* @__PURE__ */ jsxs("div", { style: { display: "flex", alignItems: "center", gap: 4 }, children: [
            /* @__PURE__ */ jsx(
              "button",
              {
                onClick: handleMenuToggle,
                "aria-label": "Toggle conversation history",
                style: {
                  display: "inline-flex",
                  height: state.buttonSize,
                  width: state.buttonSize,
                  alignItems: "center",
                  justifyContent: "center",
                  borderRadius: state.buttonBorderRadius,
                  cursor: "pointer",
                  border: "none",
                  background: "transparent",
                  color: resolveColor(state.iconColor),
                  transition: "background-color 200ms ease"
                },
                onMouseEnter: (e) => {
                  e.currentTarget.style.backgroundColor = resolveColor(state.buttonHoverBgColor) || "transparent";
                  e.currentTarget.style.color = resolveColor(state.iconColorHover) || "";
                },
                onMouseLeave: (e) => {
                  e.currentTarget.style.backgroundColor = "transparent";
                  e.currentTarget.style.color = resolveColor(state.iconColor) || "";
                },
                children: /* @__PURE__ */ jsx(PanelLeft, { size: state.iconSize, strokeWidth: 2 })
              }
            ),
            /* @__PURE__ */ jsx(
              "button",
              {
                onClick: onComposeClick,
                style: {
                  fontSize: state.titleFontSize,
                  fontWeight: getFontWeight(state.titleFontWeight),
                  color: resolveColor(state.titleColor),
                  textDecoration: "none",
                  cursor: "pointer",
                  height: state.buttonSize,
                  display: "flex",
                  alignItems: "center",
                  border: "none",
                  background: "transparent"
                },
                children: "Concierge"
              }
            )
          ] }),
          /* @__PURE__ */ jsxs("div", { style: { display: "flex", alignItems: "center", gap: 4 }, children: [
            cartCount > 0 && showComposeIcon && onBagClick && /* @__PURE__ */ jsxs(
              "button",
              {
                onClick: handleBagClick,
                "aria-label": "View shopping bag",
                style: {
                  display: "inline-flex",
                  height: state.buttonSize,
                  width: state.buttonSize,
                  alignItems: "center",
                  justifyContent: "center",
                  borderRadius: state.buttonBorderRadius,
                  cursor: "pointer",
                  position: "relative",
                  border: "none",
                  background: "transparent",
                  color: resolveColor(state.iconColor),
                  transition: "background-color 200ms ease"
                },
                onMouseEnter: (e) => {
                  e.currentTarget.style.backgroundColor = resolveColor(state.buttonHoverBgColor) || "transparent";
                  e.currentTarget.style.color = resolveColor(state.iconColorHover) || "";
                },
                onMouseLeave: (e) => {
                  e.currentTarget.style.backgroundColor = "transparent";
                  e.currentTarget.style.color = resolveColor(state.iconColor) || "";
                },
                children: [
                  /* @__PURE__ */ jsx(ShoppingBag, { size: state.iconSize, strokeWidth: 2 }),
                  /* @__PURE__ */ jsx(
                    "span",
                    {
                      style: {
                        position: "absolute",
                        top: -4,
                        right: -4,
                        backgroundColor: resolveColor(state.badgeBgColor),
                        color: resolveColor(state.badgeTextColor),
                        fontSize: state.badgeFontSize,
                        fontWeight: 500,
                        borderRadius: 9999,
                        minWidth: state.badgeMinWidth,
                        height: state.badgeMinWidth,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        paddingLeft: 4,
                        paddingRight: 4
                      },
                      children: cartCount > 99 ? "99+" : cartCount
                    }
                  )
                ]
              }
            ),
            showComposeIcon && /* @__PURE__ */ jsx(
              "button",
              {
                onClick: onComposeClick,
                "aria-label": "Compose new message",
                style: {
                  display: "inline-flex",
                  height: state.buttonSize,
                  width: state.buttonSize,
                  alignItems: "center",
                  justifyContent: "center",
                  borderRadius: state.buttonBorderRadius,
                  cursor: "pointer",
                  border: "none",
                  background: "transparent",
                  color: resolveColor(state.iconColor),
                  transition: "background-color 200ms ease"
                },
                onMouseEnter: (e) => {
                  e.currentTarget.style.backgroundColor = resolveColor(state.buttonHoverBgColor) || "transparent";
                  e.currentTarget.style.color = resolveColor(state.iconColorHover) || "";
                },
                onMouseLeave: (e) => {
                  e.currentTarget.style.backgroundColor = "transparent";
                  e.currentTarget.style.color = resolveColor(state.iconColor) || "";
                },
                children: /* @__PURE__ */ jsx(SquarePen, { size: state.iconSize, strokeWidth: 2 })
              }
            )
          ] })
        ]
      }
    ),
    /* @__PURE__ */ jsx(
      ConversationHistoryDrawer,
      {
        open: isDrawerOpen,
        onClose: handleDrawerClose,
        onConversationSelect: handleConversationSelect
      }
    )
  ] }) });
};
export {
  ConciergeHeader
};
//# sourceMappingURL=index.js.map
